import { cva } from "class-variance-authority";
/**
 * Text component styles following Material Design 3 type scale.
 */
export const textVariants = cva("", {
    variants: {
        variant: {
            displayLarge: "text-[3.5625rem] leading-[4rem] font-normal tracking-tight",
            displayMedium: "text-[2.8125rem] leading-[3.25rem] font-normal tracking-tight",
            displaySmall: "text-[2.25rem] leading-[2.75rem] font-normal tracking-normal",
            headlineLarge: "text-[2rem] leading-[2.5rem] font-normal tracking-normal",
            headlineMedium: "text-[1.75rem] leading-[2.25rem] font-normal tracking-normal",
            headlineSmall: "text-[1.5rem] leading-[2rem] font-normal tracking-normal",
            headlineSmallEmphasized: "text-[1.5rem] leading-[2rem] font-medium tracking-normal",
            titleLarge: "text-[1.375rem] leading-[1.75rem] font-normal tracking-normal",
            titleMedium: "text-[16px] leading-[24px] font-medium tracking-[0.15px]",
            titleSmall: "text-[0.875rem] leading-[1.25rem] font-medium tracking-wide",
            bodyLarge: "text-[1rem] leading-[1.5rem] font-normal tracking-wide",
            bodyMedium: "text-[15px] leading-[18px] font-normal tracking-normal",
            bodyMediumMobile: "text-[15px] leading-[18px] font-normal tracking-normal",
            bodySmall: "text-[12px] leading-[16px] font-normal tracking-[0.4px] font-sans",
            bodyResponsive: "text-[12px] md:text-[12px] lg:text-[14px] leading-[16px] md:leading-[16px] lg:leading-[20px] font-normal tracking-[0.4px] md:tracking-[0.4px] lg:tracking-[0.25px] text-primary md:text-primary lg:text-on-surface",
            labelLarge: "text-[0.875rem] leading-[1.25rem] font-medium tracking-wide",
            labelMedium: "text-[0.75rem] leading-[1rem] font-medium tracking-wider",
            labelSmall: "text-[0.6875rem] leading-[1rem] font-medium tracking-wider",
        },
        color: {
            default: "text-on-surface",
            "on-surface-dark": "text-on-surface-dark",
            primary: "text-primary",
            secondary: "text-secondary",
            error: "text-error",
            disabled: "text-on-surface/[0.38]",
        },
        align: {
            left: "text-left",
            center: "text-center",
            right: "text-right",
        },
        truncate: {
            true: "truncate",
            false: "",
        },
    },
    defaultVariants: {
        variant: "bodyMedium",
        color: "default",
        align: "left",
        truncate: false,
    },
});
//# sourceMappingURL=text.styles.js.map